import { render, staticRenderFns } from "./OutputDetail.vue?vue&type=template&id=317878d1&scoped=true&"
import script from "./OutputDetail.vue?vue&type=script&lang=js&"
export * from "./OutputDetail.vue?vue&type=script&lang=js&"
import style0 from "./OutputDetail.vue?vue&type=style&index=0&id=317878d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317878d1",
  null
  
)

export default component.exports